import Assignment from 'src/models/Assignment.model'

import FormsService from 'src/services/forms'

class Form {
  constructor (_form) {
    if (typeof _form !== 'undefined') {
      this.id = _form.id ? _form.id : null
      this.name = _form.name ? _form.name : null
      this.alias = _form.alias ? _form.alias : null
      this.description = _form.description ? _form.description : ''
      this.groups = _form.groups ? _form.groups : []
      this.organization_id = _form.organization_id ? _form.organization_id : null
      this.consolided_value = _form.consolided_value ? _form.consolided_value : 0
      this.completed_recently_at = _form.completed_recently_at ? _form.completed_recently_at : null
      this.consolided_value = _form.consolided_value ? _form.consolided_value : null
      this.created_by = _form.created_by ? _form.created_by : null
      this.assignment = _form.assignment ? _form.assignment : new Assignment()
      this.blocks = _form.blocks ? _form.blocks : []
      this.extra_properties_sum_label = _form.extra_properties_sum_label ? _form.extra_properties_sum_label : { value: null, prefix: null }
      this.pdf_logo = _form.pdf_logo ? _form.pdf_logo : null
      this.pdf_company = _form.pdf_company ? _form.pdf_company : null
      this.category = _form.category ? _form.category : null
      this.informative = _form.informative ? _form.informative : 0
      this.allow_gallery_photos = _form.allow_gallery_photos ? _form.allow_gallery_photos : 0
      this.hide_score = _form.hide_score ? _form.hide_score : 0
      this.responsability_label = _form.responsability_label ? _form.responsability_label : null
      this.leadership_label = _form.leadership_label ? _form.leadership_label : null
      this.name_label = _form.name_label ? _form.name_label : _form.name
      this.routines_check = _form.routines_check ? _form.routines_check : 0
      this.temperature_ia_image_evaluation = _form.temperature_ia_image_evaluation ? _form.temperature_ia_image_evaluation : 0
      this.action_plan_settings = _form.action_plan_settings || []
    } else {
      this.id = null
      this.name = null
      this.alias = null
      this.description = ''
      this.groups = []
      this.organization_id = null
      this.consolided_value = 0
      this.created_by = null
      this.completed_recently_at = null
      this.assignment = new Assignment()
      this.extra_properties_sum_label = { value: null, prefix: null }
      this.blocks = []
      this.pdf_logo = null
      this.pdf_company = null
      this.category = null
      this.informative = 0
      this.allow_gallery_photos = 0
      this.hide_score = 0
      this.responsability_label = null
      this.leadership_label = null
      this.name_label = null
      this.routines_check = 0
      this.temperature_ia_image_evaluation = 0
       this.action_plan_settings = []
    }
  }
   // Función interna para limpiar el assignment
  getCleanAssignment() {
    const cleanAssignment = { ...this.assignment }
    delete cleanAssignment.assignment_franchises

    if (Array.isArray(cleanAssignment.franchise_id)) {
      cleanAssignment.franchise_id = cleanAssignment.franchise_id.map(f =>
        typeof f === 'object' ? f.id : f
      )
    }

    return cleanAssignment
  }

  create (organizationId) {
    const payload = {
      id: this.id,
      name: this.name,
      alias: this.alias,
      description: this.description,
      groups: this.groups,
      consolided_value: this.consolided_value,
      completed_recently_at: this.completed_recently_at,
      organization_id: organizationId,
      assignment: this.getCleanAssignment(),
      extra_properties_sum_label: this.extra_properties_sum_label,
      blocks: this.blocks,
      pdf_logo: this.pdf_logo,
      pdf_company: this.pdf_company,
      category: this.category,
      informative: this.informative,
      allow_gallery_photos: this.allow_gallery_photos,
      hide_score: this.hide_score,
      responsability_label: this.responsability_label,
      leadership_label: this.leadership_label,
      routines_check: this.routines_check,
      temperature_ia_image_evaluation: this.temperature_ia_image_evaluation
    }
    return FormsService.create(payload)
  }

 update (organizationId) {
  const payload = {
    id: this.id,
      name: this.name,
      alias: this.alias,
      description: this.description,
      groups: this.groups,
      consolided_value: this.consolided_value,
      completed_recently_at: this.completed_recently_at,
      organization_id: organizationId,
      assignment: this.getCleanAssignment(),
      extra_properties_sum_label: this.extra_properties_sum_label,
      blocks: this.blocks,
      pdf_logo: this.pdf_logo,
      pdf_company: this.pdf_company,
      category: this.category,
      informative: this.informative,
      allow_gallery_photos: this.allow_gallery_photos,
      hide_score: this.hide_score,
      responsability_label: this.responsability_label,
      leadership_label: this.leadership_label,
      routines_check: this.routines_check,
  }

  return FormsService.update(payload)
}


  static fetch (form_id) {
    return FormsService.find(form_id).then(form => {
      return new this(form)
    })
  }

  static delete (id) {
    return FormsService.delete(id)
  }

  static checkDependencies (id) {
    return FormsService.checkDependencies(id)
  }

  static getGroups (form_id) {
    return FormsService.getGroups(form_id)
  }

  static addUpdateGroups (form) {
    return FormsService.addUpdateGroups(form)
  }

  // Extra methods
  // accessors

  loadAddons (addons) {
    if (typeof addons === 'undefined') {
      return
    }
    this.groups.forEach((group) => {
      group.items.forEach((item) => {
        if (typeof addons[item.id] !== 'undefined') {
          const answers = addons[item.id]
          answers.forEach((answer) => {
            if (answer.type === 'comment') {
              item.comment_addon_answer = answer.answer
              if (item.comment_addon_answer.length > 0) {
                item.comment_addon = true
              }
            } else if (answer.type === 'picture') {
              item.picture_addon_answer = answer.answer
              if (item.picture_addon_answer.length > 0) {
                item.picture_addon = true
              }
            } else if (answer.type === 'second_picture') {
              item.second_picture_addon_answer = answer.answer
              if (item.second_picture_addon_answer.length > 0) {
                item.second_picture_addon = true
              }
            } else if (answer.type === 'third_picture') {
              item.third_picture_addon_answer = answer.answer
              if (item.third_picture_addon_answer.length > 0) {
                item.third_picture_addon = true
              }
            } else if (answer.type === 'fourth_picture') {
              item.fourth_picture_addon_answer = answer.answer
              if (item.fourth_picture_addon_answer.length > 0) {
                item.fourth_picture_addon = true
              }
            }
          })
        }
      })
    })
  }

  static loadExtraProperties (answers) {
    answers = answers || []
    this.groups.forEach(group => {
      group.items.forEach(item => {
        const answer = answers.find(answer => answer.item_id === item.id)

        if (typeof answer !== 'undefined') {
          item.answer_extra_properties = answer.extra_properties
        } else {
          item.answer_extra_properties = []
        }
      })
    })
  }

  loadAnswers (answers) {
    answers = answers || []
    this.groups.forEach((group) => {
      group._items.forEach((item) => {
        const answer = answers.find(answer => answer.item_id === item.id)
        if (typeof answer !== 'undefined') {
          item.answer = answer.value
        } else {
          if (item.type === 'form-checkbox') {
            item.answer = []
          } else {
            item.answer = null
          }
        }
      })
    })
  }

  get extra_properties_sum () {
    let sum = 0

    const itemsWithExtraProperties = []
    const itemsForResult = []

    this.groups.forEach((group) => {
      group.items.forEach(item => {
        if (item.extra_properties) {
          itemsWithExtraProperties.push(item)
        }
      })
    })

    itemsWithExtraProperties.forEach(item => {
      const for_result = item.extra_properties.filter(extra_property => extra_property.sum_for_result)[0]

      if (for_result) {
        for_result.item_id = item.id
        itemsForResult.push(for_result)
      }
    })

    itemsWithExtraProperties.forEach(item => {
      itemsForResult.forEach(item_for_result => {
        if (item.id === item_for_result.item_id) {
          const answer = item.answer_extra_properties.find(answer => answer.key === item_for_result.key)
          if (answer) {
            sum += parseFloat(answer.value)
          }
        }
      })
    })

    return sum.toFixed(2)
  }
}

export default Form

//   //accessors

//   get extra_properties_sum_label() {
//     return this.attributes.extra_properties_sum_label
//   }

//   set extra_properties_sum_label(extra_properties_sum_label) {
//     this.attributes.extra_properties_sum_label = extra_properties_sum_label
//   }

//   get blocks() {
//     return this.attributes.blocks
//   }

//   set blocks(blocks) {
//     this.attributes.blocks = blocks
//   }

//   get company_standard() {
//     if (this.attributes.assignment) {
//       return this.attributes.assignment.company_standard
//     }
//     return 0
//   }
//   get result() {
//     var real_value = 0
//     var max_value = 0;
//     this.attributes.groups.forEach((group) => {
//       real_value += group.real_value;
//       max_value += group.max_value;
//     })

//     return max_value > 0 ?
//       parseInt((real_value / max_value * 100).toFixed(2)) :
//       100
//   }

//   get result_values() {
//     var results = [];
//     this.attributes.groups.forEach((group) => {
//       group.items.forEach((item) => {
//         results.push(item.id_value);
//       })
//     });

//     return results;
//   }
//   get addons_values() {
//     var results = [];
//     this.attributes.groups.forEach((group) => {
//       group.items.forEach((item) => {
//         if ((item.visible_comment_addon && item.comment_addon_answer) || (item.attrs.comment_addon && item.comment_addon_answer)) {
//           var c = {
//             type: 'comment',
//             item_id: item.id,
//             occurrence_id: null,
//             answer: item.comment_addon_answer
//           }
//           results.push(c);
//         }
//         if ((item.visible_picture_addon && item.picture_addon_answer) || (item.attrs.picture_addon && item.picture_addon_answer)) {
//           var p = {
//             type: 'picture',
//             item_id: item.id,
//             occurrence_id: null,
//             answer: item.picture_addon_answer
//           }
//           results.push(p);
//         }

//       });
//     });
//     return results;
//   }

//   get name() {
//     if (!(this.attributes.name)) {
//       return ''
//     }
//     return this.attributes.name
//   }

//   set name(name) {
//     this.attributes.name = name
//   }

//   get organization_id() {
//     if (!(this.attributes.organization_id)) {
//       return ''
//     }
//     return this.attributes.organization_id
//   }

//   set organization_id(organization_id) {
//     this.attributes.organization_id = organization_id
//   }

//   get description() {
//     if (!(this.attributes.description)) {
//       return ''
//     }
//     return this.attributes.description
//   }

//   set description(description) {
//     this.attributes.description = description
//   }

//   addGroup(new_group) {
//     this.attributes.groups.push(new_group)
//   }

//   get groups() {
//     return this.attributes.groups
//   }

//   set groups(groups) {
//     this.attributes.groups = groups;
//   }

//   get assignment() {
//     return this.attributes.assignment
//   }

//   set assignment(assignment) {
//     this.attributes.assignment = assignment;
//   }

//   get id() {
//     return this.attributes.id
//   }

//   set id(id) {
//     this.attributes.id = id
//   }

//   get edit() {
//     return '/my-forms/' + this.id
//   }
// }
